import React from 'react'
import '../styles/MemberDetails.css'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SideBar from '../components/SideBar';
import '../styles/WalletPage.css';
import cash from'../assets/images/tc-cash-wallet 1.png';
import units from'../assets/images/tc-units-wallet 2.png';

function CustomerWalletPage() {
    const location = useLocation();
    const customer = location.state?.customer;
    const navigate = useNavigate();

    const goToWallet = () => {
      navigate('/customer-wallet-details', {state: {customer}})
    }

    const goToRequestHistory = () => {
        navigate('/customer-cash-request-history', {state: {customer}})
    }

    const goToCustomerDetails = () => {
        navigate('/customer-details', {state: {customer}})
    }

    console.log("Received customer:", customer);

    // Safely access wallet data with fallbacks
    const walletDetails = customer?.wallet_details || {};
    const totalPoints = walletDetails.total_points || 0;
    const primaryWalletPoints = walletDetails.primary_wallet?.points || 0;
    const secondaryWalletPoints = walletDetails.secondary_wallet?.points || 0;
    
    // Get recent transactions if available
    const recentTransactions = walletDetails.recent_transactions || [];

  return (
    <div className="member-details-layout">
      <SideBar />

        <div className="member-details-main">

            {/* Header */}
            <div className="details-header">
                <h2>Customer Details</h2>
                <p>You can edit your details to update your profile</p>
            </div>

            {/* Breadcrumb */}
            <div className="breadcrumb">
                <Link to="/dashboard" className="breadcrumb-link">Home</Link>
                <span className="breadcrumb-separator">{">"}</span>
                <Link to="/manage-customer" className="breadcrumb-link">Manage Customer</Link>
                <span className="breadcrumb-separator">{">"}</span>
                <span className="breadcrumb-current">Customer Details</span>
            </div>

            {/* buttons */}
            <div className="top-bar">
            {/* tap buttons */}
                <div className="top-buttons">
                    <button className="tab-btn" onClick={goToCustomerDetails}>Personal Details</button>
                    <button className="tab-btn active" onClick={goToWallet}>Wallet Details</button>
                    <button className="tab-btn" onClick={goToRequestHistory}>Cash Request History</button>
                </div>
            </div>

            {/* Wallet Section */}
            <div className="wallet-section">
                <div className="wallet-card">
                    <h3>TCUK TopCoin Wallet</h3>
                    <img src={units} alt="Units Wallet" className="wallet-img" />
                    <p className="balance-label">Available Balance</p>
                    <h2 className="balance-value">{totalPoints.toLocaleString()} units</h2>
                     <Link to="/customer-units-transaction-history" state={{customer}} className="wallet-link">
                    Transaction History &gt;&gt;
                    </Link>
                </div>

                <div className="wallet-card">
                    <h3>TCUK Cash Wallet</h3>
                    <img src={cash} alt="Cash Wallet" className="wallet-img" />
                    <p className="balance-label">Available Balance</p>
                    <h2 className="balance-value">N/A</h2>
                </div>
            </div>

            {/* Recent Transactions Section */}
            {recentTransactions.length > 0 && (
                <div className="recent-transactions-section">
                    <h3>Recent Transactions</h3>
                    <div className="transactions-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Type</th>
                                    <th>Amount</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {recentTransactions.map((transaction, index) => (
                                    <tr key={transaction.id || index}>
                                        <td>{transaction.date}</td>
                                        <td>
                                            <span className={`transaction-type ${transaction.transaction_type}`}>
                                                {transaction.transaction_type}
                                            </span>
                                        </td>
                                        <td className={`amount ${transaction.transaction_type}`}>
                                            {transaction.transaction_type === 'credit' ? '+' : '-'}{transaction.amount}
                                        </td>
                                        <td>{transaction.description}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {recentTransactions.length >= 10 && (
                        <Link to="/customer-units-transaction-history" className="view-all-link">
                            View All Transactions &gt;&gt;
                        </Link>
                    )}
                </div>
            )}
        </div>       
    </div>
  )
}

export default CustomerWalletPage